import React, { useState } from "react";
import ArrowToggleBtn from "../components/ArrowTogglebtn";

const faqData = [
  {
    q: "How is MM Coding Lingo and what services do you offer?",
    a: "MM Coding Lingo is a full-service digital solutions agency that helps businesses grow through innovation and technology. We specialize in Artificial Intelligence & Machine Learning, Web Development, Digital Marketing, and UI/UX Design — helping brands build strong online presences and data-driven digital experiences.",
  },
  {
    q: "Why should I choose MM Coding Lingo?",
    a: "Our team blends technical expertise with creative strategy. Whether you need a custom AI solution, a conversion-optimized website, or an engaging digital campaign, we ensure every project is built with scalability, performance, and user experience in mind.",
  },
  {
    q: "Can you help with both design and development?",
    a: "Absolutely. Our team includes skilled UI/UX designers, front-end and back-end developers, and AI engineers who work collaboratively to deliver complete end-to-end solutions.",
  },
  {
    q: "Do you offer ongoing support or maintenance?",
    a: "Yes! We provide post-launch support, website maintenance, and continuous optimization for digital marketing and AI models — ensuring your systems run smoothly and efficiently over time.",
  },
];

export default function FAQs() {
  const [openItems, setOpenItems] = useState([]);

  const toggleItem = (index) => {
    setOpenItems((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <div className="w-full bg-white font-roboto shadow-lg p-4 sm:p-6 lg:p-10 rounded-2xl border-x border-b border-gray-200 mt-10 flex flex-col items-center">
      {/* Heading */}
      <section id="FAQs" className="flex flex-col items-center text-center">
        <span className="px-4 py-1 text-white bg-[#B20925] rounded-lg">
          Frequent Asked Questions
        </span>
        <h1 className="mt-4 text-2xl sm:text-3xl font-semibold">
          Everything You Need To Know
        </h1>
      </section>

      {/* FAQ Items */}
      <div className="flex flex-wrap justify-center w-full mt-10 gap-3 px-4 sm:px-10">
        {faqData.map((item, idx) => {
          const isOpen = openItems.includes(idx);
          return (
            <div
              key={idx}
              onClick={() => toggleItem(idx)}
              className={`flex flex-wrap justify-between items-start w-full rounded-lg p-5 cursor-pointer transition-all duration-300 ${
                isOpen
                  ? "border-2 border-[#B20925] bg-gray-50 shadow-lg"
                  : "border border-transparent"
              }`}
            >
              {/* Question & Answer */}
              <div className="flex-1 min-w-[250px]">
                <h2 className="text-lg font-semibold text-gray-900 mb-2">
                  {item.q}
                </h2>
                {isOpen && (
                  <p className="text-gray-700 text-base leading-relaxed">
                    {item.a}
                  </p>
                )}
              </div>

              {/* Toggle Button */}
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  toggleItem(idx);
                }}
                className="flex-shrink-0 ml-4"
              >
                <ArrowToggleBtn open={isOpen} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
